import React, { useState } from 'react';
import { FormattedMessage, } from '../../util/reactIntl';
import { DraftContent, IconArrowHead } from '../../components';

import css from './ListingPage.module.css';

const SectionDescription = props => {
  const { name, title, description, hideAccordionTitle = false } = props;

  if (!description) return null;

  const [showSection, setShowSection] = useState(true);

  return (
    <section className={css.section}>
      <h2
        className={css.sectionTitle}
        onClick={() => hideAccordionTitle ? {} : setShowSection(!showSection)}
      >
        {title}
        {!hideAccordionTitle && <IconArrowHead direction={showSection ? "up" : "down"} />}
      </h2>
      {showSection && (
        <DraftContent draftContent={description} />
      )}
    </section>
  );
};

export default SectionDescription;
